var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import kfetch from '@kareo/kfetch';
import rollbar from 'shared-assets/src/errors/errors';
import sharedConfig from 'shared-assets/src/config-environments/config';
import closeFilledSvg from 'shared-assets/assets/icons/close-alt.svg';
export var AI_ASSISTANT_ENABLED_FT = 'dark-feature.tebra-ai-assistant';
var FORETHOUGHT_SCRIPT_URL = 'https://solve-widget.forethought.ai/embed.js';
var APP_NAME = 'PO Web';
/** Class functionality to display Forethought AI widget */
var ForethoughtLoader = /** @class */ (function () {
    function ForethoughtLoader() {
    }
    /**
     * Loads the Forethought SDK functionality into the page adding an async script
     * It takes in the persistanceId which is a combination of the trigger action and timestamp,
     * as well as the inidData which provides customer insights information
     * @returns {Promise} - Returns a promise that resolves true if the Forethought SDK is properly loaded
     */
    ForethoughtLoader.loadScript = function (persistenceId, initData, onCloseCallback) {
        var _this = this;
        var scriptPromise = Promise.resolve(true);
        if (window) {
            window.ForethoughtSettings = {
                visible: false,
                chatOpen: false,
            };
        }
        if (!document.querySelector('#forethought-chat')) {
            scriptPromise = new Promise(function (resolve, reject) {
                var _a;
                try {
                    // ? Remove old widget, if it exists:
                    (_a = document.querySelector('#forethought-chat')) === null || _a === void 0 ? void 0 : _a.remove();
                    var userRoleFlags = _this.getUserRoleFlags(initData === null || initData === void 0 ? void 0 : initData.userRoles);
                    var script = document.createElement('script');
                    script.type = 'text/javascript';
                    script.id = 'forethought-widget-embed-script';
                    script.async = true;
                    script.src = FORETHOUGHT_SCRIPT_URL;
                    script.setAttribute('data-api-key', String(initData === null || initData === void 0 ? void 0 : initData.apiKey));
                    script.setAttribute('position-x', 'right');
                    script.setAttribute('config-ft-persistence-id', persistenceId);
                    var action = (persistenceId === null || persistenceId === void 0 ? void 0 : persistenceId.split('-')[0]) || '';
                    // optional attributes
                    script.setAttribute('data-ft-app', APP_NAME);
                    script.setAttribute('data-ft-env', sharedConfig === null || sharedConfig === void 0 ? void 0 : sharedConfig.environment);
                    script.setAttribute('data-ft-customer-action', action);
                    script.setAttribute('data-ft-customer-id', String(initData === null || initData === void 0 ? void 0 : initData.customerId));
                    script.setAttribute('data-ft-is-provider', String(userRoleFlags === null || userRoleFlags === void 0 ? void 0 : userRoleFlags.isProvider));
                    script.setAttribute('data-ft-is-admin', String(userRoleFlags === null || userRoleFlags === void 0 ? void 0 : userRoleFlags.isAdmin));
                    script.setAttribute('data-ft-is-biller', String(userRoleFlags === null || userRoleFlags === void 0 ? void 0 : userRoleFlags.isBiller));
                    script.setAttribute('data-ft-is-office-staff', String(userRoleFlags === null || userRoleFlags === void 0 ? void 0 : userRoleFlags.isOfficeStaff));
                    script.setAttribute('data-ft-is-financial-analyst', String(userRoleFlags === null || userRoleFlags === void 0 ? void 0 : userRoleFlags.isFinancialAnalyst));
                    script.setAttribute('data-ft-is-clinical-assistant', String(userRoleFlags === null || userRoleFlags === void 0 ? void 0 : userRoleFlags.isClinicalAssistant));
                    script.setAttribute('data-ft-user-full-name', String(initData === null || initData === void 0 ? void 0 : initData.userFullName));
                    script.setAttribute('data-ft-user-guid', String(initData === null || initData === void 0 ? void 0 : initData.userGuid));
                    script.setAttribute('data-ft-user-email', String(initData === null || initData === void 0 ? void 0 : initData.userEmail));
                    script.setAttribute('data-ft-practice-specialty', String(initData === null || initData === void 0 ? void 0 : initData.practiceSpecialty));
                    script.setAttribute('data-ft-practice-guid', String(initData === null || initData === void 0 ? void 0 : initData.practiceGuid));
                    script.setAttribute('data-ft-practice-id', String(initData === null || initData === void 0 ? void 0 : initData.practiceId));
                    script.setAttribute('data-ft-active-products', String(initData === null || initData === void 0 ? void 0 : initData.activeProducts));
                    script.setAttribute('data-ft-provider-names', String(initData === null || initData === void 0 ? void 0 : initData.providerNames));
                    script.setAttribute('data-ft-provider-count', String(initData === null || initData === void 0 ? void 0 : initData.providerCount));
                    script.onload = function () {
                        if (window) {
                            window.ForethoughtSettings = {
                                visible: true,
                                chatOpen: false,
                            };
                            ForethoughtLoader.onCloseCallback = onCloseCallback;
                            ForethoughtLoader.addCloseButton();
                        }
                        resolve(true);
                    };
                    ForethoughtLoader.addEventListeners();
                    document.head.append(script);
                }
                catch (error) {
                    reject(error);
                }
            });
        }
        return scriptPromise;
    };
    /**
     * EventListeners to hide/show the close button depending on the state of the chat
     */
    ForethoughtLoader.addEventListeners = function () {
        window.addEventListener('message', function (event) {
            var _a, _b;
            if (((_a = event === null || event === void 0 ? void 0 : event.data) === null || _a === void 0 ? void 0 : _a.event) == 'forethoughtWidgetClosed') {
                ForethoughtLoader.updateCloseButtonVisibility(true);
                window.ForethoughtSettings.chatOpen = false;
            }
            else if (((_b = event === null || event === void 0 ? void 0 : event.data) === null || _b === void 0 ? void 0 : _b.event) == 'forethoughtWidgetOpened') {
                ForethoughtLoader.updateCloseButtonVisibility(false);
                window.ForethoughtSettings.chatOpen = true;
            }
        });
    };
    /**
     * Creates a wrapper div for the chat widget and close button
     * @returns {HTMLDivElement}
     */
    ForethoughtLoader.createWrapper = function () {
        var wrapper = document.createElement('div');
        wrapper.style.position = 'fixed';
        wrapper.style.bottom = '90px';
        wrapper.style.right = '5px';
        wrapper.style.zIndex = '1000000';
        return wrapper;
    };
    /**
     * Adds a close button to the Forethought chat widget
     */
    ForethoughtLoader.addCloseButton = function () {
        var _a;
        // Get the iframe element
        var iframe = document.getElementById(ForethoughtLoader.IFRAME_ID);
        if (!iframe) {
            return;
        }
        // Create a wrapper div to contain both the iframe and close button
        var wrapper = ForethoughtLoader.createWrapper();
        // Add the wrapper to the document where the iframe is
        (_a = iframe.parentNode) === null || _a === void 0 ? void 0 : _a.insertBefore(wrapper, iframe);
        // Move the iframe into the wrapper
        wrapper.appendChild(iframe);
        // Create the close button
        ForethoughtLoader.closeButton = ForethoughtLoader.createCloseButton(iframe);
        // Add the close button to the wrapper
        wrapper.appendChild(ForethoughtLoader.closeButton);
        wrapper.addEventListener('mouseover', function () {
            if (!window.ForethoughtSettings.chatOpen) {
                ForethoughtLoader.updateCloseButtonVisibility(true);
            }
        });
        wrapper.addEventListener('mouseout', function () {
            ForethoughtLoader.updateCloseButtonVisibility(false);
        });
    };
    /**
     * Creates a styled close button for the chat widget
     * @param {HTMLIFrameElement} iframe
     * @returns {HTMLButtonElement}
     */
    ForethoughtLoader.createCloseButton = function (iframe) {
        var _this = this;
        var closeButton = document.createElement('button');
        closeButton.innerHTML = "<img src=\"" + closeFilledSvg + "\" alt=\"Close\"/>";
        Object.assign(closeButton.style, {
            position: 'absolute',
            right: '4px',
            top: '0',
            zIndex: "" + ((+iframe.style.zIndex || 999999) + 1),
            cursor: 'pointer',
            border: 'none',
            borderRadius: '50%',
            width: '24px',
            height: '24px',
            display: 'none',
            padding: 0,
        });
        closeButton.addEventListener('click', function () {
            _this.toggleVisibility();
            if (typeof ForethoughtLoader.onCloseCallback === 'function') {
                ForethoughtLoader.onCloseCallback();
            }
        });
        return closeButton;
    };
    /**
     * Updates the visibility of the close button based on widget state
     */
    ForethoughtLoader.updateCloseButtonVisibility = function (show) {
        if (!this.closeButton)
            return;
        this.closeButton.style.display = show ? 'flex' : 'none';
    };
    /**
     * Toggles the AI widget visibility
     */
    ForethoughtLoader.toggleVisibility = function () {
        var _a;
        try {
            if (!window.ForethoughtSettings)
                return false;
            var isCurrentlyVisible = (_a = window.ForethoughtSettings) === null || _a === void 0 ? void 0 : _a.visible;
            // Update widget
            window.Forethought('widget', !isCurrentlyVisible ? 'show' : 'hide');
            window.ForethoughtSettings.visible = !isCurrentlyVisible;
            // Update close button
            this.updateCloseButtonVisibility(false);
            return !isCurrentlyVisible;
        }
        catch (error) {
            rollbar.error(error);
        }
        return false;
    };
    /**
     * Map user role types into flags
     * @param roles
     * @returns
     */
    ForethoughtLoader.getUserRoleFlags = function (roles) {
        var isProvider = false;
        var isAdmin = false;
        var isBiller = false;
        var isOfficeStaff = false;
        var isFinancialAnalyst = false;
        var isClinicalAssistant = false;
        roles === null || roles === void 0 ? void 0 : roles.forEach(function (role) {
            switch (role.id) {
                case 1:
                    isAdmin = true;
                    break;
                case 2:
                    isProvider = true;
                    break;
                case 4:
                    isClinicalAssistant = true;
                    break;
                case 5:
                    isOfficeStaff = true;
                    break;
                case 6:
                    isBiller = true;
                    break;
                case 7:
                    isFinancialAnalyst = true;
                    break;
                default:
                    break;
            }
        });
        return {
            isProvider: isProvider,
            isAdmin: isAdmin,
            isBiller: isBiller,
            isOfficeStaff: isOfficeStaff,
            isFinancialAnalyst: isFinancialAnalyst,
            isClinicalAssistant: isClinicalAssistant,
        };
    };
    /**
     * Fetches the initialization data for Forethought
     * @returns initialization data for Forethought
     */
    ForethoughtLoader.getInitData = function () {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function () {
            var initDataUrl, response, initData, error_1;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _d.trys.push([0, 2, , 3]);
                        initDataUrl = '/customer-insights-ui/api/customer-ai-context';
                        return [4 /*yield*/, kfetch(initDataUrl)];
                    case 1:
                        response = _d.sent();
                        if (response) {
                            initData = {
                                apiKey: response.apiKey,
                                customerId: response.customerId,
                                userFullName: response.userFullName,
                                userGuid: response.userGuid,
                                userEmail: response.userEmail,
                                userRoles: response.userRoleDTOS,
                                practiceSpecialty: response.practiceSpecialty,
                                practiceId: response.practiceId,
                                practiceGuid: response.practiceGuid,
                                activeProducts: (_a = response.activeProducts) === null || _a === void 0 ? void 0 : _a.join(' | '),
                                providerNames: (_b = response.providerNames) === null || _b === void 0 ? void 0 : _b.join(' | '),
                                providerCount: (_c = response.providerNames) === null || _c === void 0 ? void 0 : _c.length,
                            };
                            return [2 /*return*/, initData];
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _d.sent();
                        rollbar.error("Forethought getInitData error: " + error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/, {}];
                }
            });
        });
    };
    ForethoughtLoader.closeButton = null;
    ForethoughtLoader.IFRAME_ID = 'forethought-chat';
    return ForethoughtLoader;
}());
export default ForethoughtLoader;
